import * as React from "react"

import { Search } from "lucide-react"

import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"

export interface SearchInputProps extends React.ComponentProps<typeof Input> {
  containerClassName?: string
}

export function SearchInput({
  className,
  containerClassName,
  ...props
}: SearchInputProps) {
  return (
    <div className={cn("relative w-full flex-1", containerClassName)}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
      <Input
        className={cn(
          "pl-10 bg-white/50 border-gray-200 focus-visible:ring-[color:var(--agent-ring)]",
          className
        )}
        {...props}
      />
    </div>
  )
}
